import {SectionWithOptionalCtaPageComponent} from './section-with-optional-cta.page-component';
import {StringTransformer} from './string-transformer';

export class VehiclesPageComponent extends SectionWithOptionalCtaPageComponent<
  VehiclesPageComponent,
  'vehicles'
> {
  public grid: boolean;
  constructor(el: any = {}) {
    super(
      el,
      'vehicles',
      {required: true, hasTitle: true},
      {hasText: true, required: false},
    );
    this.grid = el.grid;
  }

  public override getSearchKeys(): string[] {
    return ['sectionText.plainText', 'sectionTitle'];
  }

  public override toJson(): any {
    return {
      ...super.toJson(),
      grid: this.grid,
    };
  }

  public override applyStringTransformer(transformer: StringTransformer) {
    const res = new VehiclesPageComponent(this.toJson());

    res.sectionTitle = transformer.transform(this.sectionTitle);
    res.sectionText = {...res.sectionText, stringTransformer: transformer};

    return res;
  }
}
